
import api from './api';

export const welfareService = {
  // Categories
  getCategories: async (includeInactive = false) => {
    const response = await api.get('/welfare/categories', {
      params: { includeInactive },
    });
    return response.data;
  },
  getHomeCategories: async (includeInactive = false) => {
    const response = await api.get('/welfare/home-categories', {
      params: { includeInactive },
    });
    return response.data;
  },
  /**
   * تعداد خدمات یک زیرکتگوری خاص
   */
  getSubCategoryItemsCount: async (categoryId, subCategoryId) => {
    const response = await api.get('/welfare/services/count', {
      params: { categoryId, subCategoryId },
    });
    return response.data.count;
  },
  getCategoryById: async (id) => {
    const response = await api.get(`/welfare/categories/${id}`);
    return response.data;
  },

  createCategory: async (data) => {
    const response = await api.post('/welfare/categories', data);
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await api.put(`/welfare/categories/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await api.delete(`/welfare/categories/${id}`);
    return response.data;
  },

  // Services
  getServices: async (categoryId = null, isFeatured = null, subCategoryId = null) => {
    const params = {};
    if (categoryId) params.categoryId = categoryId;
    if (isFeatured !== null) params.isFeatured = isFeatured;
    if (subCategoryId) params.subCategoryId = subCategoryId;
    const response = await api.get('/welfare/services', { params });
    return response.data;
  },

  searchServices: async (query) => {
    const response = await api.get('/welfare/services/search', {
      params: { q: query },
    });
    return response.data;
  },

  getServiceById: async (id) => {
    const response = await api.get(`/welfare/services/${id}`);
    return response.data;
  },

  getServiceBySlug: async (slug) => {
    const response = await api.get(`/welfare/services/slug/${slug}`);
    return response.data;
  },

  createService: async (data) => {
    const response = await api.post('/welfare/services', data);
    return response.data;
  },

  updateService: async (id, data) => {
    const response = await api.put(`/welfare/services/${id}`, data);
    return response.data;
  },

  deleteService: async (id) => {
    const response = await api.delete(`/welfare/services/${id}`);
    return response.data;
  },

  // Ratings
  createRating: async (data) => {
    const response = await api.post('/welfare/ratings', data);
    return response.data;
  },

  updateRating: async (id, data) => {
    const response = await api.put(`/welfare/ratings/${id}`, data);
    return response.data;
  },

  deleteRating: async (id) => {
    const response = await api.delete(`/welfare/ratings/${id}`);
    return response.data;
  },

  getServiceRatings: async (serviceId) => {
    const response = await api.get(`/welfare/services/${serviceId}/ratings`);
    return response.data;
  },

  getServiceAverageRating: async (serviceId) => {
    const response = await api.get(`/welfare/services/${serviceId}/ratings/average`);
    return response.data;
  },

  getUserRating: async (serviceId) => {
    const response = await api.get(`/welfare/services/${serviceId}/ratings/user`);
    return response.data;
  },

  getAllRatings: async (page = 1, limit = 20) => {
    const response = await api.get('/welfare/ratings', {
      params: { page, limit },
    });
    return response.data;
  },

  toggleRatingStatus: async (id) => {
    const response = await api.put(`/welfare/ratings/${id}/toggle-status`);
    return response.data;
  },

  // حذف نظر توسط ادمین
  adminDeleteRating: async (id) => {
    const response = await api.delete(`/welfare/ratings/${id}/admin`);
    return response.data;
  },

  // ثبت/ویرایش پاسخ ادمین به نظر
  replyToRating: async (id, reply) => {
    const response = await api.put(`/welfare/ratings/${id}/reply`, { reply });
    return response.data;
  },
};

export default welfareService;
